import(/* webpackMode: "eager", webpackExports: ["default"] */ "C:\\Users\\MALLESWARI\\OneDrive\\Desktop\\jkstaffing\\jkstaffing\\src\\app\\services\\components\\ServicesCTA.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "C:\\Users\\MALLESWARI\\OneDrive\\Desktop\\jkstaffing\\jkstaffing\\src\\app\\services\\components\\ServicesDetail.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "C:\\Users\\MALLESWARI\\OneDrive\\Desktop\\jkstaffing\\jkstaffing\\src\\app\\services\\components\\ServicesHero.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "C:\\Users\\MALLESWARI\\OneDrive\\Desktop\\jkstaffing\\jkstaffing\\src\\components\\Footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "C:\\Users\\MALLESWARI\\OneDrive\\Desktop\\jkstaffing\\jkstaffing\\src\\components\\Header.tsx");
